import { render, staticRenderFns } from "./Refund.vue?vue&type=template&id=04b0534a&"
import script from "./Refund.vue?vue&type=script&lang=js&"
export * from "./Refund.vue?vue&type=script&lang=js&"
import style0 from "./Refund.vue?vue&type=style&index=0&id=04b0534a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports